export default __webpack_public_path__ + "static/media/innovation-authority.ce0d3ff6.png";